// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__2ZqWb","brand":"Navbar_brand__2B_bf"};